module.exports = __webpack_public_path__ + "static/media/tlyfe@3x.434ebe0e.png";